import { render, staticRenderFns } from "./Mediakit.vue?vue&type=template&id=7352fb1c&"
import script from "./Mediakit.vue?vue&type=script&lang=js&"
export * from "./Mediakit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports